import CurrentOrganization from './CurrentOrganization'

export default CurrentOrganization



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/DobovoTab/MappingTabs/CurrentOrganization/index.js